export const getConnectionWithID = (state, getters) => (id) => {
  let connectionObject = state.listOfConnections.find(conn => conn.ID + '' === id)
  connectionObject.connectionTypes = JSON.parse(JSON.stringify(state.allConnectionTypes))
  connectionObject.connectionTypes.map(function (c) {
    if (c._name === connectionObject.connectionType._name) {
      c._selected = true
    } else {
      c._selected = false
    }
  })
  return connectionObject
}

export const getSelectedItemsForGivenDropdownID = (state) => (dropdownID) => {
  let dropdown = state.allDropdownMenus[dropdownID]
  if (typeof dropdown === 'undefined') {
    return []
  }
  return dropdown.listOfItems.filter(function (items) {
    return items._SELECTED_DROPDOWN_PAGE
  })
}
